/**
 * Проверка возможности обновления номера телефона
 */
export const getClaimUpdatability = () => ({
    url: '/claim/updatability',
    method: 'GET',
});
